// extracted by mini-css-extract-plugin
export default {"commentsSectionContainer":"ijSSVzoK1g","withMinHeight":"oINDeVEF1Z"};